.n{width:100%;}